import { render, staticRenderFns } from "./Resource-delete.vue?vue&type=template&id=c9b8010c"
import script from "./Resource-delete.vue?vue&type=script&lang=js"
export * from "./Resource-delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports